export const SignedStatusIcon: React.FC = ({}) => {
    return(
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17.827" viewBox="0 0 18 17.827">
        <path id="Caminho_272" data-name="Caminho 272" d="M18,7.428,15.466,5.774l.408-3-3.032-.021L11.562,0,9,1.62,6.438,0,5.158,2.748l-3.032.021.408,3L0,7.428,1.966,9.734.727,12.5l2.9.879.457,3L7,15.549l2,2.278,2-2.278,2.915.831.457-3,2.9-.879L16.034,9.734ZM8.114,11.859,5.158,8.9,6.335,7.726,8.107,9.5l3.545-3.545,1.2,1.177L8.121,11.859Z" transform="translate(0 0)" fill="#13a1d6" />
      </svg>
  )
}